import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import OrderAddressSearchComponent from "../../components/order/OrderAddressSearchComponent.tsx";
import ScrollToTop from "../../components/ScrollToTop.tsx";

export default function OrderIndexPage() {
    ScrollToTop()
    setTitleAndMetaDescription("Bestil lynhurtigt bredbånd fra Hiper", "Tjek her, om du kan få 1.000 Mbit bredbånd &ndash; og bestil dit internet nu. Hvorfor nøjes med mindre, hvis du kan få Hiper?")

    return (
        <div className={"page-order"}>
            <section className="flex">
                <div className="content">
                    <h1 className="heading heading--blue heading--big">
                        Bestil hurtigt og trådløst internet
                    </h1>
                    <p>
                        Når du har indtastet din fulde adresse, søger vi på, hvilke kabler der ligger i jorden og hvilken type trådløst internet, vi kan levere til din adresse.
                    </p>
                    <div id="address-wrapper" className="address-wrap">
                        <OrderAddressSearchComponent autofocus={true}/>
                    </div>
                </div>
            </section>

        </div>
    )
}
